import { useAppSelector } from "@/app/store/hooks";
import { selectContacts } from "@/entities/site_data/model/selects";
import { useDisableScroll } from "@/shared/hooks/useDisableScroll";
import { cn } from "@/shared/lib/utils";
import Footer from "@/widgets/footer/ui/Footer";
import Header from "@/widgets/header/ui/Header";
import { selectModalRequestComplated, selectRequestModalFormOpen } from "@/widgets/modal/model/selects";
import { ModalClientRequest } from "@/widgets/modal/ui/ClientRequest";
import { ModalComplated } from "@/widgets/modal/ui/Complated";
import * as React from "react";
import { forwardRef } from "react";

export interface IPageLayoutProps
  extends React.ComponentPropsWithoutRef<'main'> {
    children: React.ReactNode,
  }

export const PageLayout = forwardRef<HTMLElement, IPageLayoutProps>(
    ({ children, className }, ref) => {

        const contacts = useAppSelector(selectContacts);
        const modalOpen = useAppSelector(selectRequestModalFormOpen);
        const modalComplatedOpen = useAppSelector(selectModalRequestComplated);

        useDisableScroll(modalOpen || modalComplatedOpen);

        return (
            <main className={cn(
                'relative w-full bg-main-grey',
                className
            )} ref={ref}>

                <Header
                    contacts={contacts}
                />

                {children}

                <Footer
                    contacts={contacts}
                />

                {
                    modalOpen
                    &&
                    <ModalClientRequest/>
                }

                {
                    modalComplatedOpen
                    &&
                    <ModalComplated/>
                }

            </main>
        );
    }
);

PageLayout.displayName = "PageLayout";
